import styled from '@emotion/styled';
import React from 'react';

const SystemLabel = styled.p`
  color: rgb(111, 111, 111);
  font-size: ${({ size }) => (size === 'small' ? '0.7rem' : '0.8rem')};
  margin: ${({ size }) => (size === 'small' ? '0.2rem 0 0.1rem 0' : '0.2rem 0 0.3rem 0')};
`;

const SystemValue = styled.p`
  color: rgb(11, 34, 54);
  font-size: ${({ size }) => (size === 'small' ? '1.1rem' : '1.4rem')};
  font-weight: 500;
  margin-bottom: ${({ size }) => (size === 'small' ? '0.8rem' : '1rem')};
`;

const SystemAttribute = ({ label, children, size = 'default' }) => (
  <>
    <SystemLabel size={size}>{label}</SystemLabel>
    <SystemValue size={size}>{children}</SystemValue>
  </>
);

export default SystemAttribute;
